import { useEffect } from 'react';
import { FormikProps } from 'formik';

interface formikValueInterface {
  newValue: string | { value: string };
  shouldBePublished: boolean;
}

export const useFieldPropagationToggle = <T extends Record<string, any>>({
  formikValue = { newValue: '', shouldBePublished: false} as formikValueInterface,
  defaultValue,
  label,
  setFieldValue,
  disabled = false
}: {
  formikValue: formikValueInterface;
  defaultValue: string;
  label: string;
  setFieldValue: FormikProps<T>['setFieldValue'];
  disabled?: boolean;
}) => {
  if(!formikValue) {
    formikValue = { newValue: '', shouldBePublished: false};
  }
  const currentValue = typeof formikValue.newValue === 'object' && formikValue.newValue !== null && 'value' in formikValue.newValue
    ? formikValue.newValue.value
    : formikValue.newValue as string;

  const isNewValueEmpty = !currentValue?.length;
  const hasValueChanged = defaultValue !== currentValue;

  useEffect(() => {
    if (!disabled) {
      const shouldBePublished = hasValueChanged && !isNewValueEmpty;
      if (formikValue.shouldBePublished !== shouldBePublished) {
        setFieldValue(`${label}.shouldBePublished`, shouldBePublished);
      }
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [currentValue, defaultValue, label, setFieldValue, disabled]);

  if (disabled) {
    return {
      isToggleDisabled: false
    };
  }

  return {
    isToggleDisabled: !hasValueChanged || isNewValueEmpty
  };
};
